// ...existing code...

// Agrega la animación con keyframes en un style tag global si no tienes tailwind.config.js personalizado
const zoomKeyframes = `
@keyframes zoom-bounce {
  0% { transform: scale(1);}
  20% { transform: scale(1.08);}
  40% { transform: scale(0.96);}
  60% { transform: scale(1.04);}
  80% { transform: scale(0.98);}
  100% { transform: scale(1);}
}
`;
if (
  typeof window !== "undefined" &&
  !document.getElementById("zoom-bounce-style")
) {
  const style = document.createElement("style");
  style.id = "zoom-bounce-style";
  style.innerHTML = zoomKeyframes;
  document.head.appendChild(style);
}

const CardSelect = ({
  data = [],
  value,
  onChange,
  name,
  error,
  multiple = false,
  isDesktop = false,
}) => {
  const isSelected = (val) =>
    multiple ? Array.isArray(value) && value.includes(val) : value === val;

  const handleSelect = (val) => {
    let newValue;
    if (multiple) {
      if (isSelected(val)) {
        newValue = value.filter((v) => v !== val);
      } else {
        newValue = [...(value || []), val];
      }
    } else {
      newValue = val;
    }
    onChange && onChange({ target: { name, value: newValue } });
  };

  // Si hay más de 3 tarjetas, usar grid de 2 columnas; si no, columna única
  const isGrid = Array.isArray(data) && data.length > 4;
  const isTwoColumns = Array.isArray(data) && data.length === 4;

  const containerClass = (() => {
    if (isGrid) {
      return isDesktop
        ? "grid grid-cols-3 gap-4 w-full"
        : "grid grid-cols-2 gap-4 w-full";
    }
    if (isTwoColumns) {
      return "grid grid-cols-2 gap-4 w-full";
    }
    return "flex flex-col gap-4 w-full";
  })();

  return (
    <div
      className={`${containerClass}`}
      style={{
        height: isDesktop
          ? "-webkit-fill-available"
          : data.length > 4 && !isDesktop && "59vh",
        overflow: "auto",
        flexDirection: isDesktop ? "row" : "column",
        alignItems: isDesktop && "center",
        display: isDesktop && data.length === 2 && "flex",
        justifyContent: isDesktop && data.length === 2 && "center",
        gap: data.length > 4 && !isDesktop && "9px",
      }}
    >
      {data.map((item) => (
        <button
          key={item.value}
          type="button"
          onClick={() => handleSelect(item.value)}
          className={`
                        flex flex-col items-center w-full rounded-2xl align justify-center border-3 
                        ${
                          isSelected(item.value)
                            ? "border-purpleM"
                            : "border-grayM"
                        }
                        focus:outline-hidden hover:border-purpleM hover:shadow-2xl duration-200
                    `}
          style={
            error
              ? {
                  animation: "zoom-bounce 0.5s",
                  height: isGrid ? "15vh" : "16vh",
                  width: isGrid
                    ? "-webkit-fill-available"
                    : isDesktop && data.length === 2 && "21vw",
                }
              : {
                  cursor: "pointer",
                  backgroundColor: "#2C2447",
                  borderColor: isSelected(item.value) ? "#A68AFF" : "#687099",
                  boxShadow: isSelected(item.value)
                    ? "0px 0px 4px #7e02fc66"
                    : "none",
                  height: isGrid ? "15vh" : item.description === "" ? "16vh" : "19vh",
                  width: isGrid
                    ? "-webkit-fill-available"
                    : isDesktop && data.length === 2 && "20vw",
                    gap: item.description && "4px"
                }
          }
        >
          <span>{isSelected(item.value) ? item.iconSelected : item.icon}</span>

          <span
            className={`border-grayM font-bold2`}
            style={{
              letterSpacing: "1px",
              fontSize: "clamp(18px, 1.2vw, 20px)",
              color: isSelected(item.value) ? "#A68AFF" : "#687099",
            }}
          >
            {item.label}
          </span>

          {item.description && (
            <span
              className={`border-grayM font-bold2`}
              style={{
                letterSpacing: "1px",
                fontSize: "clamp(8px, 1vw, 12px)",
                color: isSelected(item.value) ? "#A68AFF" : "#687099",
              }}
            >
              {item.description}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default CardSelect;
